module.exports = __webpack_public_path__ + "static/media/12_3.4423d24c.png";